module.exports = __webpack_public_path__ + "img/18_79.f12a4a89.png";